<template>
  <div class="hello" >
    <el-container class="layout-container">
      <!--头部信息-->
      <el-header class="el-header" >
        <div class="title">
          <span>ARENA</span>
        </div>
      </el-header>
      <!--侧栏信息-->
      <el-container>
        <el-aside width="300px"  style="height: 90vh">
          <el-scrollbar style="height: 100%;" wrapStyle="overflow-x:hidden;">
            <el-menu active-text-color="#409EFF" default-active="2-1-1">

              <el-submenu index="1">
                <template #title>
                  <i class="el-icon-s-data"></i>
                  <span>Database Information</span>
                </template>
                <el-submenu v-for="(value, table) in tableList" :key="table" :index="table">
                  <template #title>{{ table }}</template>
                  <el-menu-item v-for="(colType, col) in value" :key="col" :index="col">
                    {{ col }} ({{ colType }})
                  </el-menu-item>
                </el-submenu>
              </el-submenu>

              <el-submenu index="6" v-show="hide">
                <template #title>
                  <i class="el-icon-s-operation"></i>
                  <span>Method</span>
                </template>
                  <el-menu-item index="6-1">
                    <el-radio-group v-model="methodRadio" @change="methodChange">
                      <el-radio class="smallRightMargin" :label="0">AQP</el-radio>
                      <el-radio class="smallRightMargin" :label="1">Cost_Based</el-radio>
                      <el-radio class="smallRightMargin" :label="2">Random</el-radio>
                    </el-radio-group>
                  </el-menu-item>
              </el-submenu>

              <el-submenu index="2">
                <template #title>
                  <i class="el-icon-s-order"></i>
                  <span>Parameter</span>

                </template>
                <el-menu-item-group class="largeMenuItem">
                  <el-menu-item index="2-1-1" class="noHighLight">
                    <el-form label-width="90px" label-position="left" :rules="formRule" :model="queryForm" size="mini">
                      <el-form-item label="Model" v-show="methodRadio === 0">
                        <el-switch v-model="queryForm.mode" active-text="I-TIPS" inactive-text="B-TIPS" > </el-switch>
                      </el-form-item>
                      <el-form-item label="Tree Edit dist">
                        <el-switch v-model="queryForm.editFlag"></el-switch>
                      </el-form-item>
<!--                      只有当 B-APQ 的模式下才显示 Number 模块-->
                      <el-form-item label="Number" v-show="!queryForm.mode" prop="number">
                        <el-input v-model="queryForm.number"></el-input>
                      </el-form-item>
                      <el-form-item label="S_weight" >
                        <el-input v-model="queryForm.s_weight"></el-input>
                      </el-form-item>
                      <el-form-item label="C_weight" >
                        <el-input v-model="queryForm.c_weight"></el-input>
                      </el-form-item>
                      <el-form-item label="Cost_weight" >
                        <el-input v-model="queryForm.cost_weight"></el-input>
                      </el-form-item>
                      <el-form-item label="lambda" >
                        <el-input v-model="queryForm.lambda"></el-input>
                      </el-form-item>
                      <el-form-item label="Filter Limit" >
                        <el-input v-model="queryForm.filter"></el-input>
                      </el-form-item>
                    </el-form>
                  </el-menu-item>

                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="5">
                <template #title>
                  <i class="el-icon-s-tools"></i>
                  <span>Setting</span>
                </template>
                  <!--                是否比较不同plan的开关-->
                  <el-menu-item index="5-1">
                    <el-switch v-model="isComparePlan" active-text="Compare Plan"></el-switch>
                  </el-menu-item>

                  <!--                开关：控制是否根据节点类型的不同而在绘制树时使用不同的颜色-->
                  <el-menu-item index="5-2">
                    <el-switch v-model="isDifferentColor" active-text="Different Color"></el-switch>
                  </el-menu-item>

<!--                是否开启未经过完全测试的功能-->
                  <el-menu-item index="5-2">
                    <el-switch v-model="isEarlyAccess" active-text="Early Access" @change="changeEarlyAccess"></el-switch>
                  </el-menu-item>
              </el-submenu>

              <el-submenu index="3">
                <template #title>
                  <i class="el-icon-s-comment"></i>
                  <span>Suggest</span>
                </template>

                <el-menu-item-group style="height: 130px">
                  <el-menu-item index="3-1" class="noHighLight">
                    <el-input type="textarea" :rows="6" placeholder="Please input your suggestion." v-model="userSuggestion" style="font-size: 13px">
                    </el-input>
                  </el-menu-item>
                </el-menu-item-group>

                <el-menu-item-group>
                  <el-menu-item index="3-2">
                    <el-button size="mini" @click="submitSuggest">Submit</el-button>
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>

              <el-submenu index="4">
                <template #title>
                  <i class="el-icon-question"></i>
                  <span>Help</span>
                </template>
                <el-menu-item index="4-1">
                  <router-link tag='a' target='_blank' to="about" >
                  About
                  </router-link>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-scrollbar>
        </el-aside>
        <!--主体信息-->
        <el-main>
          <el-row :gutter="20" class="el-row">
            <el-col :span="9" class="el-col">

              <el-row class="el-row">
                <el-input type="textarea" placeholder="Input your SQL or select an example SQL" :autosize="{minRows:10, maxRows:20}" v-model="SQLstatement"  />
              </el-row>

              <!--                            选择框 和 提交按钮-->
              <el-row :gutter="10" class="el-row">
                <el-col :span="7" class="el-col">
                  <el-select v-model="selectedSQL" @change="loadSQLFile($event)" @clear="clearTextarea" placeholder="Example" clearable>
                    <el-option v-for="singleFile in SQLFiles" :value="singleFile" :key="singleFile">
                      {{singleFile}}
                    </el-option>
                  </el-select>
                </el-col>

                <el-col :span="2" class="el-col">
                  <el-button :loading="isLoading" @click="submitSQL" type="primary">Execute</el-button>
                </el-col>

              </el-row>
              <el-row class="el-row">
                <el-col class="el-col">
                  <el-card v-if="tableData.length > 0" class="box-card" shadow="hover">
                    <el-table v-if="tableData.length > 0"
                              :data="tableData"
                              highlight-current-row
                              @row-click="handleTableSelect"
                              style="width: 100%"
                              :default-sort="{prop:'number'}"
                              stripe>
<!--                      @current-change="handleTableSelect"-->
<!--                      <el-table-column type="expand">-->  <!-- 将 cost 信息隐藏的表格 -->
<!--                        <template v-slot="props">-->
<!--                          <el-form inline>-->
<!--                            <el-form-item label="Cost">-->
<!--                              <span>{{ props.row.cost }}</span>-->
<!--                            </el-form-item>-->
<!--                          </el-form>-->
<!--                        </template>-->
<!--                      </el-table-column>-->
                      <el-table-column prop="number" label="Id" width="40"></el-table-column>
                      <el-table-column prop="s_dist" label="S_dist" width="67"></el-table-column>
                      <el-table-column prop="c_dist" label="C_dist" width="67"></el-table-column>
<!--                      <el-table-column prop="cost_dist" label="Cost_dist"></el-table-column>-->
                      <el-table-column prop="cost" label="Cost"></el-table-column>
                      <el-table-column prop="relevance" label="Relevance"></el-table-column>
                    </el-table>
                  </el-card>
                </el-col>
              </el-row>
              <el-row v-show="tableData.length > 0 && queryForm.mode">
                <el-radio-group v-model="itips_rate" size="medium">
                  <el-radio-button label="good" ></el-radio-button>
                  <el-radio-button label="default"></el-radio-button>
                  <el-radio-button label="bad"></el-radio-button>
                </el-radio-group>
              </el-row>
            </el-col>
            <el-col :span="15" class="el-col">
              <el-card class="box-card" v-show="needToDraw != null">
                <draw-tree ref="drawTree"></draw-tree>
              </el-card>
            </el-col>
          </el-row>

        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import DrawTree from "@/components/DrawTree";

export default {
  name: 'HelloWorld',
  components: {DrawTree},
  data () {
    return {
      dbName: 'school',
      tableList: {},
      SQLstatement: '',
      selectedSQL: '',  // 选择的 SQL 文件名
      SQLFiles: [],
      isLoading: false,
      tableData: [],  // 要绘制的表格的信息 其中每一行的信息为：number cost s_dist c_dist cost_dist tree
                      // tree 中包含如下信息: rootId nodes links TABLE SCAN JOIN diffInfo
                      // diffInfo 是一个对象，包含以下信息： scanInfo joinInfo。 scanInfo 是一个对象列表，每一个是表名和扫描方式的映射
                      // joinInfo 是一个对象，包含：level map。level 是一个对象，key 是不同的层数，value 是相应的 join操作，key 越小，优先执行
                      // map 同样是一个对象，记录了每个 join 操作对应的子节点
      isComparePlan: false,  // 是否比较两个 plan 的信息
      isDifferentColor: true,  // 是否根据节点类型的不同，对树中不同节点使用不同颜色
      isEarlyAccess: true,  // 是否开启体验版的功能
      userSuggestion: '',
      queryForm: {mode: false, editFlag: false, s_weight: 0.33, c_weight:0.33, cost_weight:0.33, lambda: 0.5, number: 5, filter: 0.5},  // 查询时需要发送的主要表单数据
      formRule : {
      },
      needToDraw: null,
      methodRadio: 0,
      hide:false,
      itips_rate:'default',
    }
  },
  methods: {
    /**
     * 当用户选择的方法发生改变时进行的处理
     */
    methodChange(val) {
      if(val !== 0)
      {
        this.queryForm.mode = false;
      }
    },

    getSQLFiles() {
      console.log(process.env.BASE_API)
      this.$axios.get("/sqlFile")
        .then((response)=> {
          for(var i in response.data){
            this.SQLFiles.push(response.data[i]);
          }
          this.SQLFiles.sort(function (a,b) {
            return Number(a.split('.')[0]) - Number(b.split('.')[0]);
          })
        })
        .catch((error)=> {
          console.log("获取sql文件列表失败");
          console.log(error);
          this.SQLFiles = [];
        });
    },

    getDBInfo() {
      this.$axios.get("/databaseInfo/"+this.dbName )
        .then((response)=> {
          this.tableList = JSON.parse(response.data)
        })
        .catch((error)=> {
          console.log("获取数据库信息失败");
          console.log(error);
          this.tableList = {"请求数据库失败" : {"Cat't": "get dbInfo"}}
        });

    },

    // 取得名字为 target 的 cookie 值
    getCookie(target) {
      let strcookie = document.cookie;
      let arrcookie = strcookie.split("; ")
      for(let s of arrcookie){
        let arr = s.split("=");
        if (arr[0] === target) {
          return arr[1]
        }
      }
      return ""
    },

    checkForm() {
      // 检查 queryForm 中的 s_weight , c_weight, cost_weight, lambda, filter
      let keyList = ["s_weight", "c_weight", "cost_weight", "lambda", "filter"];
      for (let key of keyList)
      {
        let value = this.queryForm[key];
        if (value === undefined || value.length === 0)
        {
          this.$message({message: key + ' is empty!', showClose:true, type:'warning'});
          return false;
        }

        value = parseFloat(value);
        if(value < 0 || value > 1)
        {
          this.$message({message: key + ' range is [0, 1]', showClose:true, type:'warning'});
          return false;
        }
      }
      return true;
    },

    /**
     * 清空文本框区域的所有内容
     */
    clearTextarea() {
      this.clearCookie("pid");  // 用户选择的 sql 文件发生改变后，不能继续执行之前的 I-AQP
      this.SQLstatement = '';
      this.tableData = [];
      this.needToDraw = null;
    },

    loadSQLFile($event) {
      console.log("调用 loadSQLFile");
      this.clearCookie("pid");  // 用户选择的 sql 文件发生改变后，不能继续执行之前的 I-AQP
      // 因为这个影响这个函数的是选择框的改变事件，并且该选择框提供了清空的选项
      // 所以存在 this.selectedSQL 从有内容变为无内容的情形
      if (this.selectedSQL.length > 0){
        // console.log(this.selectedSQL);
        var targetURL = '/sqlFile/' + this.selectedSQL;

        this.$axios.get(targetURL )
          .then((response)=> {
            // console.log(response)
            this.SQLstatement = response.data;
          })
          .catch((error)=> {
            console.log("请求sql文件内容失败, 目标sql文件为：" + this.selectedSQL);
            console.log(error);
            this.SQLstatement = "I can't load the sql file ╮(╯-╰)╭";
          });
        // 清空表格，同时清空右侧的图
        this.tableData = [];
        this.needToDraw = null;
      }
    },

    // 发送文本框中的SQL查询给web服务器
    submitSQL() {
      console.log("点击按钮");
      // 首先判断当前是否可以发送请求
      if (this.SQLstatement === ''){  // 输入语句为空
        this.$message({message: 'Please input the SQL!', showClose:true, type:'warning'});
        return;
      }
      if(! this.checkForm())
      {
        return;
      }
      this.isLoading = true;

      // 对其中的数据进行清洗
      let formData = new FormData();
      let statement = this.SQLstatement.toLowerCase();
      // 删除其中的注释
      let lineList = statement.split('\n');
      for(let i=0;i<lineList.length;i++) {
        // 对于每一行，找到注释的起始位置，删除之后的所有内容
        let line = lineList[i]
        let commentIndex = line.indexOf("--")
        if (commentIndex !== -1){
          line = line.substring(0, commentIndex)
        }
        lineList[i] = line
      }
      statement = lineList.join('\n')
      statement = statement.replace(/\s+/g, ' ');  // 将多余的空格替换为单个空格
      formData.append('statement', statement);
      formData.append('fileName', this.selectedSQL);
      for(let key in this.queryForm){
        formData.append(key, this.queryForm[key])
      }
      formData.append('method', this.methodRadio);  // 用户想要使用哪种方法查询: 正常 cost_based random
      // 检查本地是否存储了email 信息，如果没有存储，转到登录页面
      let tempEmail = localStorage.getItem("email");
      if (tempEmail === null || tempEmail.length === 0) {  // 没有存储，需要跳转
        this.$router.replace("/login");
      } else{  // 已经存储了，在表单中添加该信息
        formData.append('email', tempEmail);
      }
      //添加调整信息
      let tmp_rate = 0;
      if(this.itips_rate === 'good'){
        tmp_rate = 1;
      } else if (this.itips_rate === 'bad'){
        tmp_rate = -1;
      }
      formData.append('adjust', JSON.stringify({'filter':0, 'evaluate':tmp_rate}));

      // 检查查询信息是否发生变化，如果发生变化，需要删除 pid 这个 cookie
      let queryMode = this.queryForm['mode'];
      let tempFromInfo = this.queryForm['mode'].toString()+this.queryForm['s_weight'].toString()+this.queryForm['editFlag'].toString()+
        this.queryForm['c_weight'].toString()+this.queryForm['cost_weight'].toString() + this.queryForm['lambda'].toString();
      if(tempFromInfo !== localStorage.getItem('formInfo'))
      {
        this.clearCookie("pid");
        localStorage.setItem('formInfo', tempFromInfo);
      }

      // 发送查询请求
      this.$axios.post('/search', formData, {
        header: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      }).then((response)=> {
        console.log('发送SQL查询请求成功!');
        console.log(response.data)

        // 当执行 B-AQP 或者 I-AQP 模式更新时才清除旧的数据
        if(queryMode === false) {
          this.tableData = [];  // 在加载新的数据前，先将旧数据清空
          this.clearCookie("pid");
        }

        if(queryMode === true)  // I-AQPS 模式
        {
          let serverFlag = response.data.flag;
          if(serverFlag['clear'] === true)  // 服务器通知前端需要清空展示列表
          {
            this.tableData = [];
          }
          response.data = [[this.tableData.length, response.data.data]];  // 其格式为：[id, plan]

          if(serverFlag['end'] === true)  // 服务器通知前端已经没有更多的 Plan 了
          {
            this.$message({message: 'No more plan', showClose:true, type:'warning'});
            this.isLoading = false;
            return;
          }
        }

        let tempRes;
        let tempObject;
        for(let i in response.data){
            let tempTree = {rootId: null, nodes: [], links: [], TABLE: {}, SCAN: {}, JOIN: {}, diffInfo: null};  // 临时存储树中的信息
            tempRes = {number: response.data[i][0]};
            tempObject = JSON.parse(response.data[i][1]);
            // tempRes.cost = Math.round(tempObject.cost);
            tempRes.cost = tempObject.cost.toFixed(1);
            tempRes.c_dist = tempObject.c_dist.toFixed(2);
            tempRes.s_dist = tempObject.s_dist.toFixed(2);
            tempRes.cost_dist = tempObject.cost_dist.toFixed(2);
            tempRes.relevance = tempObject.relevance.toFixed(2);
            tempRes.workerType = tempObject.workerType;  // 仅仅在做用户调查的时候有效，因为此时不同计划是由不同的 worker 选出的
            localStorage[tempRes.number] = tempRes.workerType;  // 记录，便于在浏览器调试
            // 处理树的节点信息（广度优先遍历）
            let counter=1;
            let content = tempObject.content;
            content.parent = "-1";
            let queue = [content];
            let timeStamp = new Date().getTime().toString();
            tempTree.rootId = this.selectedSQL + "_" + tempRes.number + "_" + "1" + "_" + content.name+ "_" + timeStamp;
            while(queue.length > 0){  // 只要队列中还有元素
              let size = queue.length;
              for(let j=0;j<size;j++)
              {
                let top = queue.shift();  // 取得头部元素
                // 取得当前节点的信息，id 的构成信息：selectedSQL_number_counter_name_timeStamp
                // data: 属性用于存储用户自定义属性，其中的 info 记录当前节点一些额外信息
                let node = {id: this.selectedSQL + "_" + tempRes.number + "_" + counter.toString() + '_' + top.name + '_' + timeStamp,
                            text: top.name + "\nCost:" + top.cost.toFixed(1), width:100, height:50, data:{info:''}};
                if (top.info !== ''){  // 如果节点的 info 信息不为空，也将其保存到前端中
                  node.data.info = top.info;
                }
                top.id = node.id;

                // 判断当前节点是否是某种特殊的类型
                if(top.tag === "TABLE")
                {
                  tempTree.TABLE[node.id] = true;  // 在 tempTree 中记录该信息
                  node.text = top.name;  // 对于表，不需要有 cost 信息
                } else if (top.tag === "SCAN")
                {
                  tempTree.SCAN[node.id] = true;
                } else if (top.tag === "JOIN")
                {
                  tempTree.JOIN[node.id] = true;
                }

                counter++;
                tempTree.nodes.push(node);
                if (top.parent !== "-1"){  // 不是根节点，需要构造边的信息
                  let edge = {from: top.parent, to:node.id};
                  tempTree.links.push(edge);
                }
                // 将所有子节点加入队列
                if (top.child_flag){  // 存在子节点
                  for (let c of top.child){
                    c.parent = node.id;
                    queue.push(c);
                  }
                }
              }
            }

            tempTree.diffInfo = this.generateDiffInfo(tempObject.content);
            // console.log("plan的差异信息为：", testRes);

            console.log("生成的树结构为：", tempTree);
            tempRes.tree = tempTree;
            this.tableData.push(tempRes);
        }
        this.isLoading = false;
        this.itips_rate = 'default';
      }).catch((error)=> {
        this.$message({message: 'SQL Execution Failed', showClose:true, type:'error'});
        this.isLoading = false;
        this.itips_rate = 'default';
        console.log('发送SQL查询请求失败!');
        console.log(error);
      })
    },

    // // 发送反馈信息给服务器
    // submitFeedback(){
    // // 首先判断反馈的信息是否合法
    //   // 信息填写是否完整
    //   if (this.bestPlanId.length === 0 || this.bestPlanReason.length === 0
    //   || this.worstPlanId.length === 0 || this.worstPlanReason.length === 0){
    //     this.$message({message: 'Please Complete the Information', showClose:true, type:'error'});
    //     return;
    //   }
    //   // 还需要判断当前是否执行了一个 SQL
    //   if (this.selectedSQL === ''){
    //     this.$message({message: 'Please execute a SQL!', showClose:true, type:'error'});
    //     return;
    //   }
    //
    // // 发送信息
    //   // 构造表单
    //   let formData = new FormData();
    //   formData.append('uid', this.getCookie('uid'));
    //   formData.append('fileName', this.selectedSQL);
    //   formData.append("bestPlanId", this.bestPlanId);
    //   formData.append("bestPlanReason", this.bestPlanReason);
    //   formData.append("worstPlanId", this.worstPlanId);
    //   formData.append("worstPlanReason", this.worstPlanReason);
    //
    //   // 发送
    //   this.$axios.post('/feedback', formData, {
    //     header: {
    //       'Content-Type': 'application/x-www-form-urlencoded',
    //     }
    //   }).then(()=> {
    //     console.log('发送反馈信息成功');
    //     this.$message({message: "thank you for your feedback!", showClose:true, type:'success'})
    //     this.bestPlanId = '';
    //     this.bestPlanReason = '';
    //     this.worstPlanId = '';
    //     this.worstPlanReason = '';
    //     this.isLoading = false;
    //   }).catch((error)=> {
    //     this.$message({message: "Can't send the feedback.", showClose:true, type:'error'});
    //     console.log('发送反馈失败!');
    //     console.log(error);
    //   })
    // },

    submitSuggest() {
      if (this.userSuggestion === ''){  // 空字符串
        this.$message({message: 'suggestion is empty!', showClose:true, type:'warning'});
        return;
      }

      // 发送信息
      // 构造表单
      let formData = new FormData();
      formData.append('uid', this.getCookie('uid'));
      formData.append('suggestion', this.userSuggestion);

      // 发送
      this.$axios.post('/suggest', formData, {
        header: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      }).then(()=> {
        this.$message({message: "thank you for your suggestion!", showClose:true, type:'success'})
        this.userSuggestion = '';
      }).catch((error)=> {
        this.$message({message: "Can't send the suggestion.", showClose:true, type:'error'});
        console.log('发送建议失败!');
        console.log(error);
      })
    },

    handleTableSelect(val) {
      if (this.isComparePlan === false){  // 不需要比较两个树的结构
        // val 是一个对象，即表格每一行的对象，转换为相应的格式后，可以直接绘制树形图
        console.log("选择的数据为：", val);
        this.needToDraw = val.tree;
        for(let i =0;i<this.needToDraw.nodes.length;i++){
          delete this.needToDraw.nodes[i].flated
        }
        this.$refs.drawTree.setGraphData(this.needToDraw, this.isDifferentColor);
      } else {  // 需要在新页面比较两棵树的结构
        // 首先生成需要传递信息的索引，并将信息存储在 localStorage 中，将索引发送给子页面
        // 子页面根据收到的索引获取相应的信息
          // 生成索引：时间戳_文件名_planId
        let index1 = new Date().getTime().toString() + "_" + this.selectedSQL + "_" + val.number;
          // 生成数据：[bestPlan的信息，selectedPlan的信息] 以JSON的格式存储，先找到best plan
        let best = null;
        for(let t of this.tableData){
          if (t.number === 0) {
            best = t;
          }
        }

        // 删除 flated 节点的信息，不然会报错
        for(let i =0;i<val.tree.nodes.length;i++){
          delete val.tree.nodes[i].flated
        }
        for(let i =0;i<best.tree.nodes.length;i++){
          delete best.tree.nodes[i].flated
        }

        let jsonStr = JSON.stringify([best.tree, val.tree]);
        localStorage.setItem(index1, jsonStr);
        localStorage.setItem(index1+"diffColor", this.isDifferentColor);  // 是否绘制不同的颜色
        // console.log("写入 localStorage 成功\n");
        let routerJump = this.$router.resolve({path: "/compareTree", query:{index: index1}});
        window.open(routerJump.href);
      }
    },

    // 一些与 DOM 元素无关的函数，再其它函数中调用


    /**
     * 生成用于比较两个 plan 之间的差别的信息
      * @param {Object} content 一个树形结构的对象
     * @return {Object} {scanInfo, joinInfo}
     */
    generateDiffInfo(content) {
      let tempScanInfo = this.generateScanInfo(content);
      let scanInfo = {}
      for(let temp of tempScanInfo) {
        for(let key in temp) {
          scanInfo[key] = temp[key];
        }
      }

      let tree = this.generateJoinTree(content);  // 只由 JOIN节点 和 TABLE节点 生成的树
      let joinInfo = this.generateJoinInfo(tree);
      let res = {};
      res["scanInfo"] = scanInfo;
      res["joinInfo"] = joinInfo;
      return res
    },

    generateScanInfo(content) {
      let temp = content;
      if (Object.keys(temp).length === 0){  // 空的对象
        return [];
      }

      if (temp.tag === "SCAN"){  // 该节点是扫描节点，直接获得子节点的名字并返回
        let c = temp.child;
        let t2n = {};
        t2n[c[0].name] = [temp.name, c[0].id];
        return [t2n];
      }

      // 对于普通节点，返回子节点的信息
      let res = [];
      for (let c of temp.child) {
        let tempRes = this.generateScanInfo(c);
        if (tempRes.length > 0){
          res = res.concat(tempRes)
        }
      }
      return res;
    },

    /**
     * 利用广度优先遍历生成后续判断 join 差异的关键信息
     * @param joinTree
     * @return {Object} 包含以下键：{level: 不同深度所对应的 join, map: 每个join节点对应的子节点}
     */
    generateJoinInfo(joinTree) {
      let res = {level: {}, map: {}};
      let depth= 1;
      let queue = [joinTree];

      while(queue.length !== 0) {
        let size = queue.length;
        res.level[depth] = [];
        for(let i=0;i<size;i++){
          // 对每一层的每个节点进行如下处理：如果是 TABLE 类型，不做任何处理；
          // 如果是 JOIN 类型，取得两个子节点的 id，加入 map，将该节点的 id 加入对应的 level，再将子节点加入 queue 中
          let top = queue.shift();

          if (top.tag === "JOIN") {
            // 将该节点加入对应的 level
            res.level[depth].push(top.id);

            // 将子节点加入到映射中
            let childId = [];
            for (let c of top.child) {
              childId.push(c.id);
              queue.push(c);
            }
            res.map[top.id] = childId;
          }
        }
        depth++;
      }

      depth--;
      delete res.level[depth];
      for(let i=1,j=depth-1;i<j;i++, j--) {
        let temp = res.level[i];
        res.level[i] = res.level[j];
        res.level[j] = temp;
      }

      return res;
    },

    generateJoinTree(content) {
      let temp = content;
      if (Object.keys(temp).length === 0){
        return {};
      }

      if (temp.tag === "TABLE") {
        return {tag: temp.tag, id: temp.id, child: []}
      }

      if (temp.tag === "JOIN") {
        let res = {tag: temp.tag, id: temp.id, child: []};
        // 遍历所有子节点
        for(let c of temp.child) {
          let tempRes = this.generateJoinTree(c);
          if (Object.keys(tempRes).length > 0) {  // 合法对象，添加子节点
            res.child.push(tempRes)
          }
        }
        return res;
      }

      // 普通节点，返回所有子节点的组合
      // 正常情况下应该只有一个子节点，如果有多个子节点，报错
      if (temp.child.length > 1) {
        this.$message({message: 'dfsTree Wrong: ' + temp.name + "有两个子节点", showClose:true, type:'error'});
        return {};
      } else {  // 正常情况，返回子节点的值
        return this.generateJoinTree(temp.child[0]);
      }
    },

    /**
     * 将新状态写入 localStorage ，所有页面均能访问
     * @param {boolean} state 新的状态
     */
    changeEarlyAccess(state){
      localStorage.setItem("isEarlyAccess", state.toString());
    },

    /**
     * 删除名称为 name 的 cookie
     * @param {string} name
     */
    clearCookie(name) {
      console.log("调用 clearCookie");
      let d = new Date();
      d.setTime(d.getTime() + (-1*24*60*60*1000));
      let expires = "expires="+d.toUTCString();
      document.cookie = name + "=" + "" + "; " + expires;
    }
  },
  mounted() {
    this.getSQLFiles(); // 在初始化时首先获得所有的 sql 文件
    this.getDBInfo();
    localStorage.setItem("isEarlyAccess", "true");
    localStorage.setItem("formInfo", "");
  },

  /**
   * 在进入该页面之前先判断是否已经登录
   */
  created() {
    let temp = localStorage.getItem("email");
    console.log(temp);
    if (temp === null || temp.length === 0) {
      this.$router.replace("/login")
    } else{
      console.log("不需要跳转")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.layout-container .el-header {
  position: relative;
  background-color: #C6E2FF;
}

.layout-container .title{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 20px;
  color: #303133;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-col {
  border-radius: 4px;
}

</style>

<style>
.el-textarea__inner{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}

.el-table__body tr.current-row>td{
  background-color: #f8e3c5 !important;
}

.largeMenuItem{
  height: 300px;
}

.noHighLight:focus {
  background-color: white !important;
}

.noHighLight:hover {
  background-color: white !important;
}

.el-table__expanded-cell {
  padding: 20px 20px !important;
}

.smallRightMargin.el-radio{
  margin-right: 10px !important;
}

</style>
